export class Utils {

  public static defaultFirstPage = 0;
  public static defaultPageSize = 10;

  public static examConfig = {
    updrs: {
      score: {
        UPDRS: {
          minInterval: 0,
          maxInterval: 108
        },
        MDSUPDRS: {
          minInterval: 0,
          maxInterval: 132
        }
      }
    },
    mmseMoca: {
      score: {
        minInterval: 0,
        maxInterval: 30
      }
    },







    funzioniEsecutive: {
      score: {
        minInterval: 0,
        maxInterval: 30
      },
      categorie: {
        minInterval: 0,
        maxInterval: 6
      },
      errori: {
        minInterval: 0,
        maxInterval: 48
      }
    },

    globalCognition: {
      score: {
        minInterval: 0,
        maxInterval: 30
      }
    },

    linguaggio: {
      bada: {
        minInterval: 0,
        maxInterval: 30
      }
    },

    memoria: {
      immediata: {
        minInterval: 0,
        maxInterval: 15
      },
      differita: {
        minInterval: 0,
        maxInterval: 15
      },
      raccontino: {
        minInterval: 0,
        maxInterval: 28
      },
      diretto: {
        minInterval: 3,
        maxInterval: 9
      },
      inverso: {
        minInterval: 3,
        maxInterval: 8
      },
    },

    scaleFunzionali: {
      bdiII: {
        minInterval: 0,
        maxInterval: 63
      },
      destrimaniaAnnett: {
        minInterval: -24,
        maxInterval: 24
      },
      pasTest: {
        minInterval: 0,
        maxInterval: 48
      },
      adl: {
        minInterval: 0,
        maxInterval: 6
      },
      iadl: {
        minInterval: 0,
        maxInterval: 8
      },
    },

    visuoSpaziali: {
      copia: {
        minInterval: 0,
        maxInterval: 36
      },
      differita: {
        minInterval: 0,
        maxInterval: 36
      },
      incompleteLetter: {
        minInterval: 0,
        maxInterval: 20
      },
      numberLocation: {
        minInterval: 0,
        maxInterval: 10
      },
      dotCounting: {
        minInterval: 0,
        maxInterval: 10
      },
    },

    workingMemory: {
      matriciAttentive: {
        minInterval: 0,
        maxInterval: 60
      },
      interferenzaErrori: {
        minInterval: -30,
        maxInterval: 30
      },
    },









    depressione: {
      score: {
        BDI2: {
          minInterval: 0,
          maxInterval: 63
        },
        HADS: {
          minInterval: 0,
          maxInterval: 21
        }
      }
    },
    pittsburg: {
      score: {
        minInterval: 0,
        maxInterval: 21
      }
    },
    epoworth: {
      score: {
        minInterval: 0,
        maxInterval: 24
      }
    },
    irbdSssPaziente: {
      score: {
        minInterval: 0,
        maxInterval: 54
      }
    },
    irbdSssBedPartner: {
      score: {
        minInterval: 0,
        maxInterval: 38
      }
    },
    eqd5: {
      scoreVas: {
        minInterval: 0,
        maxInterval: 100
      }
    },
  };

  public static RandomRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  public static Log(debugmessage) {
    console.log(
      "%c Log Message: %c " + debugmessage,
      "margin: 3px; padding: 3px; border-radius: 50px; background: #5EB1BF; color: #191919",
      "background: #222; color: #bada55"
    );
  }

  public static Error(debugmessage) {
    console.log(
      "%c Error Message: %c " + debugmessage,
      "margin: 3px; padding: 3px; border-radius: 50px; background: #D33E43; color: white",
      "background: #222; color: #bada55"
    );
  }
}
